import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const Plot = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    const updatePurchaseProfile = { ...purchaseProfile, plotSize: { ...purchaseProfile.plotSize, [key]: value } }
    // dispatch(setNewPurchaseProfile(updatePurchaseProfile))
    dispatch(setLocal(props.PURCHASE_PROFILE, updatePurchaseProfile))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.plot.size-from']}</div>
        <div className="values">
          <Input
            type="number"
            suffix={translations['square-meter.symbol']}
            value={purchaseProfile.plotSize.from}
            onChange={update('from')}
            placeholder={translations['my-objects.pipeline.location-criteria.plot.size-from']}
          />
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.plot.size-until']}</div>
        <div className="values">
          <div className="values">
            <Input
              type="number"
              suffix={translations['square-meter.symbol']}
              value={purchaseProfile.plotSize.until}
              onChange={update('until')}
              placeholder={translations['my-objects.pipeline.location-criteria.plot.size-until']}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Plot
